/**
* Servicio que se ecarga de listar todas agendaciones de la app.
* JACP-2018-10-04
*/
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ConfigService } from '../../servicios/config/config.service';
import { KeyService } from '../../servicios/key.service';

@Injectable()
export class AgendamientoAppService {

    PATH = new ConfigService().obtenerPath();

    constructor(
        private http : Http,
        private _key : KeyService
    ) {}

    /**
     * Enviar registro a guardar en bd
     * JMM-2018-11-08
     */
    setAgendamiento(agendamiento:any){
        let url = this.PATH + '/api/public/agendamientoapp';
        return this.http.post(url, agendamiento, {headers:this._key.head()}).map(resp => resp.json());
    }

    /**
     * Obtener los registros del agendamiento
     * JMM-2018-11-09
     */
    getRegistrosAgendamiento(){
        let url = this.PATH + '/api/public/agendamientoapp';
        return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
    }

    /**
     * Obtener los registros del agendamiento segun el permiso dado
     * CAAA-2019-08-22
     */
    getRegistrosAgendaPermiso(listadopermisos){
        let url = this.PATH + '/api/public/agendamientoappPermiso';
        return this.http.post(url,listadopermisos, {headers:this._key.head()}).map(resp => resp.json());
    }

    /**
     * Obtener un registro por id de una familia para editar
     * JMM-2018-11-13
     */
    getRegistroAgendamiento(agendamientoid:any, pqrid:any){
        let url = this.PATH + '/api/public/getRegAgendamientoapp/'+agendamientoid+'/'+pqrid;
        return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
    }

    /**
     * Obtener los tecnicos asignados
     * JMM-2018-11-13
     */
    getTecnicosAsignados(detallepqrid:any)
    {
        let url = this.PATH + '/api/public/getTecnicosAsignados/'+detallepqrid;
        return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
    }// .getTecnicosAsignados(detallepqrid:any)

    /**
     * Editar registro en bd
     * JMM-2018-11-13
     */
    editAgendamiento(agendamiento:any){
        let url = this.PATH + '/api/public/agendamientoapp/'+agendamiento.agendamientoid;
        return this.http.put(url, agendamiento, {headers:this._key.head()}).map( resp => resp.json());
    }

      /**
     * Obtener listado de actividades de incidencias asignadas
     * CESAR ARIAS-2019-05-06
     */
    listActividadesIncidencia(pqrid:any){
        let url = this.PATH + '/api/public/listActividadesIncidencia/'+pqrid;
        return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
    }

    /**
     * Obtener los registros del agendamiento
     * JMM-2019-06-21
     */
    obtenerFiltroAgendamientoApp(info: any){
        //pendiente por terminar el fltro  en api
        let url = this.PATH + '/api/public/obtenerfiltroagendamientoapp';
        return this.http.post(url,info ,{headers:this._key.head()}).map(resp => resp.json());
    }

    /**
     * Obtener un registro por id de una familia para editar
     * JMM-2018-11-13
     */
    getRegistroCalendario(){
        let url = this.PATH + '/api/public/getRegistroCalendario';
        return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
    }

    setCalendario(form){
        let url = this.PATH + '/api/public/setCalendario';
        return this.http.post(url,form, {headers:this._key.head()}).map(resp => resp.json());
    }



    destroyCalendario(id:any){
        let url = this.PATH + '/api/public/destroyCalendario/'+id;
        return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json());
    }

    updateCalendario(form){
        let url = this.PATH + '/api/public/updateCalendario';
        return this.http.post(url,form, {headers:this._key.head()}).map(resp => resp.json());
    }

    /**
     * Enviar registro a guardar en bd multiples incidencias
     * JMM-2018-11-08
     */
    setAgendamientoMultiple(DATA:any){
        let url = this.PATH + '/api/public/setAgendamientoMultiple';
        return this.http.post(url, DATA, {headers:this._key.head()}).map(resp => resp.json());
    }

    procesoIncidencia(data:any){
        let url = this.PATH + '/api/public/procesoIncidencia';
        return this.http.post(url,data, {headers:this._key.head()}).map(resp => resp.json());
    }

    setDatoEquipo(equipoterceroid:any){
        let url = this.PATH + '/api/public/setDatoEquipo/'+equipoterceroid;
        return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
    }
}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/agendamiento-app/agendamiento-app.service.ts